<script>
	import { onMount } from "svelte";
	import { headerBlack, headerToc, headerState } from "../stores";
	import { scrollTo } from "../utils";

	import { header } from "../config";
	import svgTsp from "./tsp_logo.svg.txt";
	import svgAbo from "./abo.svg.txt";
	import svgTocSep from "./toc_sep.svg.txt";

	export let forSubscribers;

	function scroll(id) {
		scrollTo(document.querySelector("#" + id), -50);
	}

	let elemSharing;
	let elemAccount;

	let hideAccountBtn = true;
	onMount(() => {
		const eSharing = document.querySelector(".tslr-header .tslr-sharing");
		if (eSharing && elemSharing) elemSharing.appendChild(eSharing);

		const eSso = document.querySelector(".tslr-header #sso-menu");
		eSso.style.zIndex = "5000";
		if (eSso && elemAccount) elemAccount.appendChild(eSso);

		setTimeout(() => {
			hideAccountBtn = false;
		}, 500);
	});
</script>

<div
	class="header"
	class:for-subscribers={forSubscribers}
	class:black={$headerBlack}
	class:header-toc={$headerState === "toc"}
	class:header-simple={$headerState === "simple"}
>
	<div class="header-overflow">
		<div class="sharing" bind:this={elemSharing} />

		<div class="toc" class:tocvisible={$headerToc}>
			<div class="toc-content toc-content-{$headerToc}" class:visible={$headerToc}>
				<div class="toc-item" class:active={$headerToc === "produkt"} on:click={() => scroll(header.tocProduktId)}>
					<div class="toc-item-text">{header.tocProdukt}</div>
				</div>

				{@html svgTocSep}

				<div class="toc-item" class:active={$headerToc === "national"} on:click={() => scroll(header.tocNationalId)}>
					<div class="toc-item-text">{header.tocNational}</div>
				</div>

				{@html svgTocSep}

				<div class="toc-item" class:active={$headerToc === "berlin"} on:click={() => scroll(header.tocBerlinId)}>
					<div class="toc-item-text">{header.tocBerlin}</div>
				</div>

				{@html svgTocSep}

				<div class="toc-item" class:active={$headerToc === "wochenende"} on:click={() => scroll(header.tocWeId)}>
					<div class="toc-item-text">{header.tocWe}</div>
				</div>
			</div>
		</div>
		{#if forSubscribers}
			<div class="account" class:hide={hideAccountBtn} bind:this={elemAccount} />
		{/if}
	</div>

	<div class="header-nooverflow">
		<a class="logo" target="_blank" href="https://tagesspiegel.de">
			{@html svgTsp}
		</a>

		{#if !forSubscribers}
			<div class="abo">
				<a
					class="abo-link"
					href={header.aboLink}
					target="_blank"
					aria-describedby="message-target-blank"
					rel="noopener"
				>
					{@html svgAbo}
					<span>
						{header.aboText}
					</span>
				</a>
			</div>

			<div class="cta">
				<a class="button" href={header.ctaButtonLink} target="_blank" rel="noopener">
					{header.ctaButtonText}
				</a>
			</div>
		{/if}
	</div>
</div>

<style lang="scss">
	.header {
		height: 70px;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9;
		width: 100%;
		background-color: #fff;
		color: #000;
		border-bottom: 2px solid;
		border-color: #ececec;
		font-family: $ff-sans;
		font-size: 16px;
		line-height: 24px;
		transition: background-color 0.5s, border-color 0.1s;
	}

	.header-overflow {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		overflow: visible;
		pointer-events: none;
		transition: background-color 0.5s, border-color 0.1s;

		& > :global(*) {
			pointer-events: all;
		}
	}

	.header-nooverflow {
		position: absolute;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		overflow: hidden;
		pointer-events: none;
		transition: background-color 0.5s, border-color 0.1s;

		& > :global(*) {
			pointer-events: all;
		}
	}

	.sharing {
		position: absolute;
		top: 50%;
		left: 20px;
		transform: translateY(-50%);
		transition: opacity 0.3s;
		opacity: 1;
		z-index: 1;

		:global(.tslr-sharing) {
			top: 0;
			transform: none;
		}
	}

	.logo {
		width: 190px;
		height: 37px;
		position: absolute;
		left: calc(50% - 95px);
		top: 50%;
		transform: translateY(-50%);
		transition: transform 0.4s ease;
		display: block;

		:global(svg) {
			width: 100%;
			height: 100%;
		}

		:global(path) {
			fill: #000;
			transition: fill 0.2s;
		}
	}

	.black {
		background-color: #000;
		color: #fff;
		border-color: #131313;

		.logo {
			:global(path) {
				fill: #fff;
			}
		}
	}

	.cta-label {
		font-family: $ff-sans;
		color: #000;
		font-weight: 500;
		padding: 6px 0;
		font-size: 16px;
		line-height: 20px;
		display: inline-block;
		opacity: 0;
		pointer-events: none;
		position: absolute;
		left: 20px;
		transform: translate(-250px, -50%);
	}

	.cta {
		position: absolute;
		right: 20px;
		transform: translate(250px, -50%);
		opacity: 0;
		pointer-events: none;
		top: 50%;
		transition: transform 0.5s 1s ease;
	}

	.button {
		border-radius: 4px;
		text-align: center;
		font-family: $ff-sans;
		color: #fff;
		padding: 6px 24px;
		font-size: 16px;
		line-height: 20px;
		display: inline-block;
		font-weight: 500;
		text-decoration: none !important;
		touch-action: manipulation;
		cursor: pointer;
		box-sizing: border-box;
		display: inline-block;
		white-space: nowrap;
		background-color: #fff;
		color: #c90c0f;
		border: 1px solid #c90c0f;

		&:active,
		&:hover {
			outline: 0;
		}

		&:hover {
			color: #980402;
			border-color: #980402;
		}
	}

	.abo {
		position: absolute;
		right: 20px;
		top: calc(50% + 4px);
		transform: translateY(-50%);
		transition: opacity 0.3s;
		opacity: 1;
	}

	.abo-link {
		color: #2a2a2a;
		font-family: $ff-sans;
		font-weight: 500;
		letter-spacing: 1px;
		font-size: 12px;
		line-height: 15px;
		text-decoration: none !important;
	}

	.sharing :global(.tslr-sharing .tslr-sharing__text-mobile) {
		color: #2a2a2a;
		font-family: $ff-sans;
		font-weight: 500;
		letter-spacing: 1px;
		font-size: 12px;
		line-height: 15px;
	}

	.abo-link {
		text-align: center;
		display: inline-block;
		width: 30px;
	}

	.abo-link :global(svg) {
		width: 30px;
		display: block;
	}

	.abo-link span {
		display: block;
		margin-top: 3px;
	}

	.account {
		position: absolute;
		right: 20px;
		top: 50%;
		height: 60%;
		max-height: 60px;
		transform: translateY(-50%);
		transition: opacity 0.3s;
		opacity: 1;
		z-index: 1;

		&.hide {
			// opacity: 1 !important;
			display: none !important;
		}

		// #sso-menu {
		// 	display: none !important;
		// }
	}

	.toc {
		font-size: 18px;
		line-height: 1;
		font-family: $ff-sans;
		font-weight: 500;
		color: #2a2a2a;
		letter-spacing: 2%;
		position: absolute;
		left: 215px;
		height: 100%;
		width: calc(100% - 425px);
		opacity: 0;
		pointer-events: none;
		overflow: hidden;
		height: calc(100% + 2px);

		&::before {
			content: " ";
			position: absolute;
			left: 0;
			width: 25px;
			z-index: 1;
			background: linear-gradient(to right, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
			height: calc(100% - 2px);
		}
	}

	.toc-content {
		opacity: 0;
		pointer-events: none;
		transition: opacity 0.2s ease, transform 0.5s 0.35s ease;
		transform: translateX(-100%);
		white-space: nowrap;
		height: calc(100% - 2px);

		&.visible {
			opacity: 1;
			pointer-events: all;
		}
	}

	.toc-item {
		height: 100%;
		display: inline-flex;
		flex-direction: column;
		justify-content: center;
		cursor: pointer;
		margin: 0 25px;
		text-align: center;
		color: #9b9b9b;

		&.active {
			color: #c90c0f;
			border-bottom: 2px solid #c90c0f;
		}
	}

	.toc-item-text {
		display: inline-block;
	}

	.header.header-simple {
		.cta,
		.cta-label,
		.sharing,
		.abo,
		.account {
			opacity: 0;
			pointer-events: none;
		}
	}

	.header.header-toc {
		.cta,
		.cta-label,
		.sharing,
		.abo {
			opacity: 0;
			pointer-events: none;
		}

		.logo {
			//left: 11px;
			transform: translate(calc(11px - 50vw + 95px + var(--scrollbar-width) / 2), -50%);
		}

		.toc {
			opacity: 1;
			pointer-events: all;
		}

		.toc-content {
			transform: translateX(0);
		}

		.cta {
			transform: translate(0, -50%);
			opacity: 1;
			pointer-events: all;
		}

		.button {
			animation: ctabuttonpule 5.5s 1.3s ease forwards;
		}
	}

	@keyframes ctabuttonpule {
		0% {
			box-shadow: 0 0 0 rgba(201, 12, 15, 0);
		}
		15% {
			box-shadow: 0 1px 8px rgba(201, 12, 15, 0.2);
		}
		35% {
			box-shadow: 0 0 0 rgba(201, 12, 15, 0);
		}
		45% {
			box-shadow: 0 1px 10px rgba(201, 12, 15, 0.3);
		}
		65% {
			box-shadow: 0 0 0 rgba(201, 12, 15, 0);
		}
		80% {
			box-shadow: 0 1px 8px rgba(201, 12, 15, 0.2);
		}
		100% {
			box-shadow: 0 0 0 rgba(201, 12, 15, 0);
		}
	}

	@media (max-width: 1330px) {
		.toc-item {
			margin: 0 12px;
		}

		.toc {
			left: 208px;

			&::before {
				width: 12px;
			}
		}

		.button {
			padding: 6px 16px;
		}
	}

	@media (max-width: 1190px) {
		.toc-item {
			margin: 0 9px;
		}

		.toc {
			left: 208px;
			width: calc(100% - 406px);

			&::before {
				width: 9px;
			}

			:global(svg) {
				margin: 0 -3px;
			}
		}

		.button {
			padding: 6px 10px;
		}
	}

	@media (max-width: 1135px) {
		.toc-item {
			margin: 0 9px;
		}

		.toc {
			left: 203px;
			width: calc(100% - 390px);

			&::before {
				width: 9px;
			}

			:global(svg) {
				margin: 0 -5px;
			}
		}

		.button {
			padding: 6px 8px;
		}
	}

	@media (max-width: 1100px) {
		.toc {
			background: #fff;
			top: 100%;
			height: 36px;
			left: 0;
			width: 100%;
			border-top: 2px solid #ececec;
			border-bottom: 2px solid #ececec;
			box-sizing: border-box;
			overflow: visible;
			padding-left: 6px;
			font-size: 16px;
			line-height: 16px;
			transform: translateY(calc(-100% - 2px));
			transition: transform 0.6s ease;
		}

		.toc-content {
			height: 100%;
		}

		.header-toc .toc.tocvisible {
			transform: translateY(0);
		}

		.toc-item {
			margin: 0 12px;
		}

		.button {
			padding: 6px 24px;
		}

		.header-nooverflow {
			background: #fff;
		}

		.black .header-nooverflow {
			background: #000;
		}

		.black .toc {
			border-color: #131313;
		}
	}

	@media (max-width: 662px) {
		.header {
			height: 60px;
		}

		.button {
			padding: 6px 11px;
		}

		.toc {
			overflow: hidden;
			padding-left: 15px;
			border: none;
			background: #f4f4f4;
			text-align: left;
			height: 26px;
			font-size: 14px;
			line-height: 14px;
			transition: transform 0.4s 0.1s ease;

			&::before {
				display: none;
			}
		}

		.toc :global(svg) {
			display: none;
		}

		.toc-item {
			margin: 0;
			display: flex;
			font-weight: 600;
			align-items: flex-start;
			height: 26px;
			pointer-events: none !important;
			cursor: default;
			color: #2a2a2a;

			&.active {
				border-bottom: none;
				color: #2a2a2a;
			}
		}

		.toc-content {
			transition: transform 0.5s ease;
			transform: translateY(0) !important;
		}

		.toc-content-national {
			transform: translateY(-26px) !important;
		}

		.toc-content-berlin {
			transform: translateY(-52px) !important;
		}

		.toc-content-wochenende {
			transform: translateY(-78px) !important;
		}

		.logo {
			width: 182px;
			height: 34px;
			left: calc(50% - 91px);
		}

		.header.header-toc {
			// &:not(.for-subscribers) {
			.logo {
				transform: translate(calc(6px - 50vw + 91px + var(--scrollbar-width) / 2), -50%);
			}
			// }
			// &.for-subscribers {
			// 	.logo {
			// 		transform: translate(0, -50%);
			// 	}
			// }
		}

		.cta {
			right: 15px;
		}
	}

	@media (max-width: 366px) {
		.header-toc .logo :global(path:not(.tspt)) {
			fill: transparent;
		}
	}

	:global(.tslr--app) .header {
		display: none !important;
	}
</style>
